import NewCheckoutCard from './new-checkout-card.vue';

export default NewCheckoutCard;
